import { Box, Heading, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { useWhoisMobileOptimizations } from '../../../../hooks/useWhoisMobileOptimizations';
import { WhoisVoucherBanner } from '../../../../Components/VoucherBanner';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import s from '../whoisResultsPage.scss';
const DomainCardSkeleton = () => /*#__PURE__*/React.createElement(Box, {
  align: "space-between",
  verticalAlign: "middle",
  className: s.skeletonRow
}, /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: "SP2"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "180px",
  height: "16px"
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "80px",
  height: "14px"
})), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "80px",
  height: "32px"
}));

// Mobile-opt: badge, domain name, then price + Get It button (matches the real
// Mobile domain card layout).
const MobileDomainCardSkeleton = () => /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: "SP3",
  className: s.skeletonRow
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "110px",
  height: "20px"
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "200px",
  height: "24px"
}), /*#__PURE__*/React.createElement(Box, {
  align: "space-between",
  verticalAlign: "middle"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "140px",
  height: "20px"
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "90px",
  height: "44px"
})));
export const AlternativesSkeleton = () => {
  const isMobile = useIsMobile();
  const mobileOptimizations = useWhoisMobileOptimizations();
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const cards = Array.from({
    length: 5
  }).map((_, i) => /*#__PURE__*/React.createElement(DomainCardSkeleton, {
    key: i
  }));
  const mobileCards = Array.from({
    length: 5
  }).map((_, i) => /*#__PURE__*/React.createElement(MobileDomainCardSkeleton, {
    key: i
  }));
  if (mobileOptimizations) {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "32px",
      backgroundColor: "white",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "D60",
      borderRadius: "12px",
      overflow: "hidden",
      padding: "0 0 SP6 0"
    }, /*#__PURE__*/React.createElement(WhoisVoucherBanner, null), /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "32px",
      padding: "0 SP4"
    }, /*#__PURE__*/React.createElement(Box, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Heading, {
      size: "large",
      as: "h2"
    }, t('domain_search_gate.whois_results.mobile.suggestions_card.subtitle'))), /*#__PURE__*/React.createElement(SkeletonGroup, {
      className: s.skeletonGroup
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP6"
    }, mobileCards))));
  }
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP6",
    backgroundColor: "white",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    padding: isMobile ? '0 0 SP6 0' : 'SP5 SP6'
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "100%",
    height: "40px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "220px",
    height: "20px"
  }), cards));
};
//# sourceMappingURL=AlternativesSkeleton.js.map